module.exports = __webpack_public_path__ + "static/media/interest_revoked.96cc868a.svg";